package uz.ferro.erp.feature.country.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.model.DictItem

@Serializable
data class Country(
    val id: Long? = null,
    val key: String? = null,
    val name: DictItem? = null
)